/**
 * Analytics Constants
 * ===================
 * PURPOSE: Define action type constants for analytics Redux actions
 * 
 * WHY: String constants prevent typos and enable IDE autocomplete.
 *      Each endpoint has REQUEST, SUCCESS, and FAIL variants.
 */

// Transaction Volume (for line/area charts)
export const ANALYTICS_TRANSACTION_VOLUME_REQUEST = 'ANALYTICS_TRANSACTION_VOLUME_REQUEST';
export const ANALYTICS_TRANSACTION_VOLUME_SUCCESS = 'ANALYTICS_TRANSACTION_VOLUME_SUCCESS';
export const ANALYTICS_TRANSACTION_VOLUME_FAIL = 'ANALYTICS_TRANSACTION_VOLUME_FAIL';

// Revenue Analytics (for bar charts with comparisons)
export const ANALYTICS_REVENUE_REQUEST = 'ANALYTICS_REVENUE_REQUEST';
export const ANALYTICS_REVENUE_SUCCESS = 'ANALYTICS_REVENUE_SUCCESS';
export const ANALYTICS_REVENUE_FAIL = 'ANALYTICS_REVENUE_FAIL';

// User Growth (for area charts)
export const ANALYTICS_USER_GROWTH_REQUEST = 'ANALYTICS_USER_GROWTH_REQUEST';
export const ANALYTICS_USER_GROWTH_SUCCESS = 'ANALYTICS_USER_GROWTH_SUCCESS';
export const ANALYTICS_USER_GROWTH_FAIL = 'ANALYTICS_USER_GROWTH_FAIL';

// Real-time Stats (for dashboard cards)
export const ANALYTICS_REALTIME_REQUEST = 'ANALYTICS_REALTIME_REQUEST';
export const ANALYTICS_REALTIME_SUCCESS = 'ANALYTICS_REALTIME_SUCCESS';
export const ANALYTICS_REALTIME_FAIL = 'ANALYTICS_REALTIME_FAIL';

// Club Performance (for performance comparison)
export const ANALYTICS_CLUB_PERFORMANCE_REQUEST = 'ANALYTICS_CLUB_PERFORMANCE_REQUEST';
export const ANALYTICS_CLUB_PERFORMANCE_SUCCESS = 'ANALYTICS_CLUB_PERFORMANCE_SUCCESS';
export const ANALYTICS_CLUB_PERFORMANCE_FAIL = 'ANALYTICS_CLUB_PERFORMANCE_FAIL';

// Reset analytics state
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
